module.exports = __webpack_public_path__ + "img/facebook.20caac44.svg";